import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CollectEditDialog from '@/components/collect/CollectEidtDialog.vue';
import CollectDelDialog from '@/components/collect/CollectDelDialog.vue';
export default {
  components: {
    CollectEditDialog: CollectEditDialog,
    CollectDelDialog: CollectDelDialog
  },
  data: function data() {
    var id = this.$route.query.id;
    return {
      id: id,
      favoriteName: '',
      favoriteDesc: '',
      updatedTime: '',
      total: 0,
      instList: [],
      ifShowEditDialog: false,
      ifEditCollect: true,
      editCollect: {
        favoriteDesc: null,
        favoriteName: null,
        id: id
      },
      ifShowDelDialog: false,
      pageNum: 1,
      pageSize: 10,
      listMask: false
    };
  },
  methods: {
    toInst: function toInst(item) {
      window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(item.baseUrl).concat(item.path)));
    },
    cancelCollect: function cancelCollect(item) {
      var _this = this;
      this.listMask = true;
      var data = {
        favoritesId: this.id,
        itemIdList: [item.itemId],
        systemId: item.systemId
      };
      this.$API.postRequest({
        url: '/platform/favorite/cancelItemCollect',
        data: data
      }).then(function () {
        _this.listMask = false;
        _this.$message({
          type: 'success',
          message: '取消收藏成功'
        });
        _this.getInstList();
      });
    },
    currentChange: function currentChange(val) {
      this.pageNum = val;
      this.getInstList();
    },
    sizeChange: function sizeChange(val) {
      this.pageSize = val;
      this.getInstList();
    },
    getCollectInfo: function getCollectInfo() {
      var _this2 = this;
      this.$API.postRequest({
        url: "/platform/favorite/details?id=".concat(this.id)
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.editCollect.favoriteDesc = _this2.favoriteDesc = res.result.favoriteDesc;
          _this2.editCollect.favoriteName = _this2.favoriteName = res.result.favoriteName;
          _this2.updatedTime = res.result.updatedTime;
          _this2.total = res.result.total;
        }
      });
    },
    getInstList: function getInstList() {
      var _this3 = this;
      this.$API.postRequest({
        url: "/platform/favorite/itemList?id=".concat(this.id, "&pageNum=").concat(this.pageNum, "&pageSize=").concat(this.pageSize)
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.instList = res.result.records;
          _this3.total = res.result.total;
          if (res.result.records.length === 0 && _this3.pageNum > 1) {
            _this3.pageNum -= 1;
            _this3.getInstList();
          }
        }
      });
    },
    editCollectDialog: function editCollectDialog() {
      this.ifShowEditDialog = true;
    },
    submitCollectFn: function submitCollectFn() {
      this.ifShowEditDialog = false;
      this.getCollectInfo();
    },
    delCollectFn: function delCollectFn(obj) {
      this.ifShowDelDialog = false;
      if (obj.bool) {
        this.$router.push({
          path: '/system/collect'
        });
        this.$message({
          type: 'success',
          message: '删除成功'
        });
      }
    },
    delCollect: function delCollect() {
      this.ifShowDelDialog = true;
    }
  },
  created: function created() {
    this.getCollectInfo();
    this.getInstList();
  }
};